/**题库模块 */
import request from '../request/http';
/**新增题库 */
export function AddQuestionBank(data){
    return request({
        url: '/sp/questionBank/addQuestionBank',
        method: 'post',
        data
    })
}
/**分页查询题库 */
export function BankPageList(data){
    return request({
        url: '/sp/questionBank/bankPageList',
        method: 'post',
        data
    })
}
/**取消题库共享 */
export function CancelShareQuestionBank(data){
    return request({
        url: '/sp/questionBank/cancelShareQuestionBank',
        method: 'post',
        data
    })
}
/**删除题库 */
export function DelQuestionBank(data){
    return request({
        url: '/sp/questionBank/delQuestionBank',
        method: 'post',
        data
    })
}
/**共享题库 */
export function ShareQuestionBank(data){
    return request({
        url: '/sp/questionBank/shareQuestionBank',
        method: 'post',
        data
    })
}
/**更新题库 */
export function UpdateQuestionBank(data){
    return request({
        url: '/sp/questionBank/updateQuestionBank',
        method: 'post',
        data
    })
}
/**我创建的题库 */
export function GetMyQuestionBank(data){
    return request({
        url: '/sp/questionBank/getMyQuestionBank',
        method: 'post',
        data
    })
}